<div class="container sms010">
  <!-- ヘッダーエリア -->
  <app-header></app-header>
  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area sms010-content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">

        <div>
          <fieldset class="grid-frame">
            <br>
            <div>
              <mat-label class="message-completed">{{lblMessage01}}</mat-label>
            </div>
            <br><br>
            <div>
              <mat-label class="message">{{lblMessage02}}</mat-label>
            </div>
            <br><br>
          </fieldset>
        </div>
        <br><br>

        <!-- イメージ -->
        <div>
          <img class="image-completed" src="assets/images/completed.png" />
        </div>
      </form>
      <br>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button class="back-button" (click)="backClick()" accesskey="q" tabindex="1">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
